import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from '@/lib/axios';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [loading, setLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      const token = localStorage.getItem("authToken");
      const tokenType = localStorage.getItem("tokenType");

      if (!token || !tokenType) {
        setLoading(false);
        return;
      }

      try {
        const response = await axiosInstance.get("/users/me", {
          headers: {
            Authorization: `${tokenType} ${token}`,
          },
        });

        const user = response.data;

        const accessGranted = verifyAccess(user, requiredRole);


        setIsAllowed(accessGranted);

      } catch (error) {
        console.error('Access verification failed:', error);
        if (error.response?.status === 401) {
          localStorage.removeItem("authToken");
          localStorage.removeItem("tokenType");
        }
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [requiredRole]);

  if (loading) return <div>Loading...</div>;

  return isAllowed ? children : <Navigate to="/" replace />;
};

const verifyAccess = (user, requiredRole) => {
  if (!requiredRole) return true;

  switch (requiredRole) {
    case 'admin':
      return user.is_admin === true;
    case 'sport_participant':
      return user.account_type === 'sport_participant' && user.is_admin === false;
    case 'sport_organizer':
      return user.account_type === 'sport_organizer' && user.is_admin === false;
    default:
      return false;
  }
};

export default ProtectedRoute;
